export default __webpack_public_path__ + "static/media/spiderman-img-1.8b4cdc88.png";